import React from "react";
import ImportarCfop from "components/ImportarCfop";

const ImportarCfopPage = () => <ImportarCfop />;

export default ImportarCfopPage;
